import React from 'react'
import styles from './index.module.css'
import TabPanel from '../Common/TabPanel'
import ScanLineItem from './ScanLineItem'
import { useScansState } from './useScans'

const HistoryTabPanel = () => {

    const scans = useScansState()
    const sortedScans = [...scans.get()].sort((a, b) => b.created_at - a.created_at)

    return (
        <TabPanel>

            <div className={styles.box}>

                <h2 className={styles.title}>Scan History</h2>

                <div className={styles.scans}>
                    {sortedScans.map((scan, index) => <ScanLineItem scan={scan} key={index}/>)}
                </div>
            </div>

        </TabPanel>
    )

}

export default HistoryTabPanel
